import { render } from "./bidInvite.vue?vue&type=template&id=3a8cca06&scoped=true"
import script from "./bidInvite.vue?vue&type=script&lang=js"
export * from "./bidInvite.vue?vue&type=script&lang=js"

import "./bidInvite.vue?vue&type=style&index=0&id=3a8cca06&lang=scss"
import "./bidInvite.vue?vue&type=style&index=1&id=3a8cca06&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8cca06"]])

export default __exports__